import React from 'react'
import { ModalInjectedProps } from '@sketch/components'
import {
  WorkspaceMinimalFragment,
  ProjectFragment,
  useGetProjectQuery,
  StorageItemFragment,
} from '@sketch/gql-types'

import { ConfirmStorageItemTransferModal } from '../../../storageItems/modals/ConfirmStorageItemTransferModal'
import { useTransfer } from './ProjectListItem.hooks'

interface ConfirmStorageItemTransferModalDraggedProps
  extends ModalInjectedProps {
  workspace: WorkspaceMinimalFragment
  destinationProject: ProjectFragment
  items: (StorageItemFragment | ProjectFragment)[]
}

export const ConfirmStorageItemTransferModalDragged = (
  props: ConfirmStorageItemTransferModalDraggedProps
) => {
  const { items, destinationProject, workspace, hideModal, ...rest } = props

  const { move, loading } = useTransfer({
    workspaceId: workspace.identifier,
    newProject: destinationProject,
  })

  const [item] = items
  const currentProjectId =
    items.length === 1
      ? (item.__typename === 'Project' ? item.topLevelProject : item.project)
          ?.identifier
      : null

  // we are expecting to receive this project from a cache
  const currentProjectQuery = useGetProjectQuery({
    variables: { shortId: currentProjectId || '' },
    skip: !currentProjectId,
  })

  return (
    <ConfirmStorageItemTransferModal
      {...rest}
      loading={loading || currentProjectQuery.loading}
      onCancel={props.hideModal}
      hideModal={hideModal}
      onConfirm={async () => {
        await move(items[0])
        hideModal()
      }}
      items={items}
      destination={{
        // We are allowing to drag&drop storage items within the same workspace
        workspace,
        project: destinationProject,
      }}
      currentLocation={{
        workspace,
        project: currentProjectQuery.data?.project || null,
      }}
    />
  )
}
